import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class VaultTransactionsService {

    constructor(private http: HttpClient) { }

    /**
     * Get Cashier Transaction template.
     * @param {string} tellerId Teller Id.
     * @param {string} cashierId Cashier Id.
     * @returns {Observable<any>} Cashier Transaction data.
     */
    getCashierTransactionTemplate(tellerId: string): Observable<any> {        
        return this.http.get(`/tellers/${tellerId}/cashiers/0/transactions/template`);
    }

    /**
     * @param {string} tellerId Teller Id.
     * @param {string} cashierId Cashier Id.
     * @param {string} cashData Cash Data.
     * @returns {Observable<any>}
     */
    allocateCash(tellerId: string, cashierId: string, cashData: any): Observable<any> {
        const httpParams = new HttpParams().set('command', 'allocate');
        return this.http.post(`/tellers/${tellerId}/cashiers/${cashierId}/allocate`, cashData, { params: httpParams });
    }

    /**
   * @param {string} tellerId Teller Id.
   * @param {string} cashierId Cashier Id.
   * @param {string} cashData Cash Data.
   * @returns {Observable<any>}
   */
    settleCash(tellerId: string, cashierId: string, cashData: any): Observable<any> {
        const httpParams = new HttpParams().set('command', 'settle');
        return this.http.post(`/tellers/${tellerId}/cashiers/${cashierId}/settle`, cashData, { params: httpParams });
    }
}
